module.exports = __webpack_public_path__ + "static/media/now-4.384998e5.png";